export default function transformFilterModelFromV0ToV1(filterModelV0) {
    if (!filterModelV0)
        return [];
    const res = [];
    Object.keys(filterModelV0)
        .forEach((field) => {
        if (filterModelV0[field]) {
            const predicates = Object.keys(filterModelV0[field]);
            if (predicates.length > 0) {
                predicates.forEach((predicate) => {
                    res.push({ field: field, predicate: predicate, value: filterModelV0[field][predicate] });
                });
            }
        }
    });
    return res;
}
